// Import Libraries
import React from 'react';
import ReactDOM from 'react-dom';
// Import JS files
import PrintsBuilder from '../customer_pages/_prints-builder/desktop/prints-builder';
import MobilePrintsBuilder from '../customer_pages/_prints-builder/mobile/prints-builder';
import NewMobilePrintsBuilder from '../customer_pages/_prints-builder/mobile';
import App from '../customer_pages/_application/basket-contents-app';
import 'Utils/login-launcher';
import '../customer_pages/_prints-builder/common/debounced-scroll-handler';
import '../customer_pages/_application/iframe-login';
import '../customer_pages/_application/menu-analytics';

// Define App: moved from slim file
window.App = App;

// N.B This implementation is moved from show.html.slim file
if (bootstrapSize.isBootstrapXS() || bootstrapSize.isBootstrapSM()) {
  // Render Mobile Prints Builder Page

  if (
    window.features?.testNewMobilePrintsBuilder || (
      window.features?.displayNewMobilePrintsBuilder &&
        window.splitAbTests?.mobile_prints_builder ===
          'display_new_mobile_prints_builder'
        )
  ) {
    ReactDOM.render(
      <NewMobilePrintsBuilder
        urls={window.urls}
        features={window.features}
        initSessionTimeout={window.initSessionTimeout}
        uploadFromGalleryListenerUrl={window.uploadFromGalleryListenerUrl}
      />,
      document.getElementById('content')
    );
  } else {
    ReactDOM.render(
      <MobilePrintsBuilder
        urls={window.urls}
        features={window.features}
        initSessionTimeout={window.initSessionTimeout}
        uploadFromGalleryListenerUrl={window.uploadFromGalleryListenerUrl}
      />,
      document.getElementById('content')
    );
  }
} else {
  // Render Default Prints Builder Page
  ReactDOM.render(
    <PrintsBuilder
      urls={window.urls}
      features={window.features}
      uploadFromGalleryListenerUrl={window.uploadFromGalleryListenerUrl}
    />,
    document.getElementById('content')
  );
}
